import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import { Flex, Input, Select, Typography } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {  addAbonementClubItem, addAbonementClubService, getAbonementListClubItems, getAbonementListClubServices, getAbonementTypes } from 'src/store/Slices/AbonementsSlice'
import { openNotification } from 'src/components/helpers/notification';

const AddNewAbonementClubServices = ({ visible, setVisible, abonementCostInfo }) => {

    // HELPERS
    const dispatch = useDispatch()

    // STATE
    const [name, setName] = useState()
    const [service, setService] = useState()
    const [price, setPrice] = useState()
    const [trainings, setTrainings] = useState()
    const [image, setImage] = useState()

    const abonementServices = useSelector(state => state.AbonementsSlice.abonementServices)


    useEffect(() => {
        dispatch(getAbonementTypes())
    }, [])

    const onClickAddAbonement = () => {
        dispatch(addAbonementClubService({
            abonementClubId : abonementCostInfo.id,
            serviceId : service,
            price : price,
            personalCount : trainings,
            clubImageUrl : image,
            serviceTitle : name
        })).then(() => {
            dispatch(getAbonementListClubServices({ AbonementClubId: abonementCostInfo.id }))
            setVisible(false)
        })
    }

    return (
        <CModal
            alignment="center"
            visible={visible}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible(false) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    'Добавить услугу'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                defaultValue=""
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Услуги</Typography.Title>
                            <Select
                                style={{ width: '100%' }}
                                options={abonementServices?.data.value}
                                placeholder={'Выбрать'}
                                value={service}
                                onChange={e => setService(e)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Цена</Typography.Title>
                            <Input
                                defaultValue=""
                                type='number'
                                value={price}
                                onChange={e => setPrice(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Кол-во тренировок</Typography.Title>
                            <Input
                                defaultValue=""
                                type='number'
                                value={trainings}
                                onChange={e => setTrainings(e.currentTarget.value)}
                            />
                        </div>

                        <div>
                            <Typography.Title level={5}>Изображение</Typography.Title>
                            <Input
                                defaultValue=""
                                value={image}
                                onChange={e => setImage(e.currentTarget.value)}
                            />
                        </div>

                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible(false) }}
                    style={{ color: '#fff' }}
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton onClick={onClickAddAbonement} style={{ color: '#fff' }}>
                    Добавить
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddNewAbonementClubServices